var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationGreyIcon = function SvgLocationGreyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.576 0 3 3.399 3 9.087c0 5.958 8.367 14.44 8.723 14.798a.39.39 0 0 0 .554 0C12.633 23.527 21 15.045 21 9.087 21 3.399 16.424 0 12 0Zm0 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z",
    id: "location-grey-icon_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#7f8a99",
    fillRule: "nonzero",
    xlinkHref: "#location-grey-icon_svg__a"
  })));
};
export default SvgLocationGreyIcon;